{
  "documentTitle": "المحروقات - PDA",
  "nav": {
    "changeBranch": "تغيير الفرع",
    "systems": "الأنظمة"
  },
  "sidebar": {
    "title": "القائمة الجانبية",
    "description": "قائمة التنقل",
    "toggle": "تبديل القائمة الجانبية",
    "toggleHint": "تبديل التنقل (Ctrl/Cmd+B)"
  }
}
